// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  MUST_HAVE_A_CORRESPONDING_LATITUDE,
  MUST_HAVE_A_CORRESPONDING_LONGITUDE,
} from 'errors'

import {
  stringMustBeWithinRange,
  validateLatitude,
  validateLongitude,
} from 'validators/common'

const validate = v => {
  // Since redux-form v8, first render of the form does not have the actual initial values.
  // https://github.com/redux-form/redux-form/issues/4344
  if (Object.keys(v).length === 0) {
    return
  }

  const err = {}

  validateLatitude(v.latitude, err, true)
  // if there' a longitude but no latitude, display an error
  if (!err.latitude && !v.latitude && v.longitude) {
    err.latitude = MUST_HAVE_A_CORRESPONDING_LATITUDE
  }

  validateLongitude(v.longitude, err, true)
  // if there' a latitude but no longitude, display an error
  if (!err.longitude && v.latitude && !v.longitude) {
    err.longitude = MUST_HAVE_A_CORRESPONDING_LONGITUDE
  }

  const radius = stringMustBeWithinRange(v.radius, 0, 59)
  if (radius) {
    err.radius = radius
  }

  return err
}

export default validate
